'use client';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InputElementBase } from '../utils/types';
import GenericFormInput from './GenericFormInput';
import { useState } from 'react';
import Eye from '../icons/Eye';
import HiddenEye from '../icons/HiddenEye';

export default function InputPassword({
  label,
  description,
  className,
  disabled,
  placeholder,
  name,
  onBlur,
  onChange,
  ref,
  value,
  hasIcon,
  autoComplete,
}: Exclude<InputElementBase, 'icon'> & { hasIcon?: boolean }) {
  const [isPasswordType, setPasswordType] = useState(true);

  return (
    <FormItem className={className || undefined}>
      {label && <FormLabel>{label}</FormLabel>}
      <FormControl>
        <div className="relative">
          <GenericFormInput
            type={isPasswordType ? 'password' : 'text'}
            placeholder={placeholder || undefined}
            disabled={disabled}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            ref={ref}
            value={value}
            autoComplete={autoComplete}
          />
          {hasIcon && (
            <span
              className="absolute right-4 top-4 cursor-pointer"
              onClick={() => {
                setPasswordType((prevState) => !prevState);
              }}
            >
              {isPasswordType ? (
                <Eye className="text-slate-400" />
              ) : (
                <HiddenEye className="text-slate-400" />
              )}
            </span>
          )}
        </div>
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
}
